import { TextField, TextFieldProps } from "../FormText/TextField";

export interface TextareaFieldProps extends Omit<TextFieldProps, "type"> {}

export function TextareaField({ ...rest }: TextareaFieldProps) {
    return <TextField multiline {...rest} />;
}
